import React from 'react';
import PropTypes from 'prop-types';

// table for print
const PrintableTable = ({ checkedArray, data, fields, isWarehousePrint = false }) => (
  <table className={ `${isWarehousePrint ? "warehouse-print" : ''} printable-table`}>
    <thead>
      <tr>
        {
          fields.map((field, index) => (checkedArray ? (checkedArray[index] && (
            <th
              colSpan={field.colSpan || 1}
              key={field.name}
              className={field.name === 'discounted' || field.name === 'priceTotal' ? 'price' : field.name === 'subname' ? 'subname' : ''}
            >
              {field.label}
            </th>
          )) : (
            <th
              colSpan={field.colSpan || 1}
              key={field.name}
              className={field.name === 'discounted' || field.name === 'priceTotal' ? 'price' : field.name === 'subname' ? 'subname' : ''}
            >
              {field.label}
            </th>
            )
          ))
        }
      </tr>
    </thead>
    <tbody>
      {
        data.map((row, index) => (
          <tr key={index} className={ row.uom || row.item_uom || row.itemUom ? "order-row" : "buyer-row" } >
            {
              fields.map((field, index) => {
                const value = field.render ? field.render(row) :
                  (row.isSeparator ? '' : row[field.name]);
                const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;
                return checkedArray ? (checkedArray[index] && (
                  <td
                    colSpan={field.colSpan || 1}
                    key={index}
                    className={field.name === 'discounted' || field.name === 'priceTotal' ? 'price' : field.name === 'subname' ? 'subname' : `${field.className}` }
                    style = {{textAlign:`${field.name === 'itemQty' ? 'center': ''}`}}
                  >
                    {isEmpty || value === '' ? <br /> : value}
                  </td>
                )) : (
                  <td
                    colSpan={field.colSpan || 1}
                    key={index}
                    className={field.name === 'discounted' || field.name === 'priceTotal' ? 'price' : field.name === 'subname' ? 'subname' : ''}
                  >
                    {isEmpty || value === '' ? <br /> : value}
                  </td>
                );
              })
            }
          </tr>
        ))
      }
    </tbody>
  </table>
);

PrintableTable.propTypes = {
  checkedArray: PropTypes.arrayOf(PropTypes.bool),
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

PrintableTable.defaultProps = {
  checkedArray: null,
};

export default PrintableTable;
